import React, {useState, useEffect} from "react";
import {Link} from "react-router-dom";
import {get_user_detail} from "../apis/index";
import {Helmet} from "react-helmet";

import Sidebar from "../components/sidebar";
import "./accounts.css";
import AccountItem from "../components/account";
import CardItem from "../components/card";
import {new_account, update_config} from "../apis/index";
import {toast} from "react-toastify";
import {Button} from "antd";

const Accounts = (props) => {
  const [user_detail, setUserDetail] = useState({accounts: [], cards: []});
  const [phone_name, setPhone_name] = useState("");
  const [free_trial, setFree_trial] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const onLoad = async () => {
      let user_data = await get_user_detail();
      if (user_data) {
        console.log(user_data);

        setUserDetail(user_data);
        chec_accounts(user_data.accounts);
      }
    };

    onLoad();
  }, []);

  
  const chec_accounts = (accounts) => {
    const accountsContainer = document.querySelector(".accounts-accountscontainer");
    const emptyAccount = document.querySelector(".accounts-emptyaccount");

    if (accounts.length == 0) {
      if (accountsContainer) {
        accountsContainer.style.display = "none";
      }

      if (emptyAccount) {
        emptyAccount.style.display = "flex";
      }
    } else {
      if (accountsContainer) {
        accountsContainer.style.display = "flex";
      }

      if (emptyAccount) {
        emptyAccount.style.display = "none";
      }
    }
  };

  const handleAddNewPhone = () => {
    document.querySelector(".accounts-newphonebody").style.display = "flex";
  };

  const handleCloseNewPhoneModal = () => {
    document.querySelector(".accounts-newphonebody").style.display = "none";
  };

  const handleCloseCardModal = () => {
    document.querySelector(".accounts-choosepayment").style.display = "none";
  };

  const handleNewCardPayment = (e) => {
    e.preventDefault();

    if (!phone_name.trim()) {
      return toast.error("Please enter phone name");
    }

    let payload = {name: phone_name, isNewCard: true};
    document.querySelector(".accounts-choosepayment").style.display = "none";
    new_account(JSON.stringify(payload));
  };

  const handleSelectCard = (card_id) => {
    if (!phone_name.trim()) {
      return toast.error("Please enter phone name");
    }

    let payload = {name: phone_name, isNewCard: false, card_id: card_id};
    document.querySelector(".accounts-choosepayment").style.display = "none";
    new_account(JSON.stringify(payload));
  };

  const handleNewAccountProceed = async (e) => {
    e.preventDefault();
    if (!phone_name.trim()) {
      return toast.error("Please enter phone name");
    }
    setLoading(true);
    if (free_trial) {
      let payload = {name: phone_name, isFreeTrial: true};
      document.querySelector(".accounts-newphonebody").style.display = "none";
      await new_account(JSON.stringify(payload));
    } else if (user_detail.cards.length !== 0) {
      document.querySelector(".accounts-choosepayment").style.display = "flex";
      document.querySelector(".accounts-newphonebody").style.display = "none";
    } else {
      let payload = {name: phone_name, isNewCard: true};
      document.querySelector(".accounts-newphonebody").style.display = "none";
      await new_account(JSON.stringify(payload));
    }
    setLoading(false);
  };

  const handleStartFreeTrial = (e) => {
    e.preventDefault();
    setLoading(true);
    setFree_trial(true);
    handleAddNewPhone();
    setLoading(false);
  };

  return (
    <div className="accounts-container">
      <Helmet>
        <title>accounts - wapi</title>
        <meta property="og:title" content="accounts - wapi" />
      </Helmet>

      <div className="accounts-container01">
        <Sidebar></Sidebar>
        <div className="accounts-container02">
          <div className="accounts-container03">
            <h3 className="accounts-text">Accounts</h3>
            <button className="accounts-button button" onClick={handleAddNewPhone}>
              Add New Phone
            </button>
          </div>
          <div className="accounts-accountscontainer">
            <div className="accounts-accountitem">
              <div className="accounts-container04">
                <span className="accounts-text01">Phone Number</span>
              </div>
              <div className="accounts-container05">
                <span className="accounts-text03">Name</span>
              </div>
              <div className="accounts-container06">
                <span className="accounts-text03">Status</span>
              </div>
              <div className="accounts-container07">
                <span className="accounts-text04">Subscription</span>
              </div>
            </div>

            {user_detail.accounts.map((account) => (
              <AccountItem key={account.account_id} account={account} />
            ))}
          </div>

          <div className="accounts-emptyaccount">
            <div className="accounts-container20">
              <h1 className="accounts-text17">Nothing Here</h1>
              <span className="accounts-text18" onClick={handleStartFreeTrial}>
                Start 3 Days Free Trial
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="accounts-newphonebody">
        <div className="accounts-container21">
          <div className="accounts-container22">
            <h3 className="accounts-text19">New Account</h3>
            <svg viewBox="0 0 1024 1024" className="accounts-icon12" onClick={handleCloseNewPhoneModal}>
              <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
            </svg>
          </div>
          <div className="accounts-container23">
            <div className="accounts-container24">
              <span>Name</span>
            </div>
            <div className="accounts-container25">
              <input type="text" className="accounts-textinput input" value={phone_name} onChange={(e) => setPhone_name(e.target.value.trim())} />
            </div>
          </div>

          <div className="accounts-container26">
            <button className="accounts-button1 button" onClick={handleCloseNewPhoneModal}>
              Cancel
            </button>
            <Button loading={loading} className="accounts-button2 button" onClick={handleNewAccountProceed}>
              Proceed
            </Button>
          </div>
        </div>
      </div>

      <div className="accounts-choosepayment">
        <div className="accounts-paymentcontainer">
          <div className="accounts-paymentitem">
            <h3 className="accounts-text21">Select Payment Method</h3>
            <svg viewBox="0 0 1024 1024" className="accounts-icon14" onClick={handleCloseCardModal}>
              <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
            </svg>
          </div>

          <div className="accounts-paymentitem1">
            {user_detail.cards.map((card) => (
              <CardItem key={card.id} card={card} handleSelectCard={handleSelectCard} />
            ))}
          </div>

          <div className="accounts-paymentitem2">
            <Button className="accounts-button5 button" onClick={handleCloseCardModal}>
              Cancel
            </Button>
            <Button className="accounts-button6 button" onClick={handleNewCardPayment}>
              Use a new card
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Accounts;
